import { createReducer } from '@reduxjs/toolkit';
import { ActionReducerMapBuilder } from '@reduxjs/toolkit/src/mapBuilders';

export const initReducer = <T>(
  initialState: T,
  builder: (b: ActionReducerMapBuilder<T>) => void = () => {},
) => createReducer<T>(initialState, builder);
